import { LeoMetadata } from '@leopoly/arize-eu-insole/dist/metadata/metadata-leo';

export class LeroyUtils {
	static generateEmbossedText(line1: string, line2: string, side?: 'L' | 'R', orderID?: string) {
		const orderText = orderID ? '\n' + orderID.substr(0, 8) + '-' + side : '';
		return line1 + '\n' + line2 + orderText;
	}

	static generateFileName(line1: string, line2: string, side?: 'L' | 'R', orderID?: string) {
		return (orderID ? `${line1 + ' ' + line2}_${orderID.substr(0, 8)}_${side}` : '').toUpperCase();
	}

	static injectEmbossedTextAndFilename(data: any, line1: string, line2: string, side: 'L' | 'R', orderID?: string) {
		if (!data) {
			return data;
		}

		data.emboss = data.emboss || {};
		data.emboss.embossedText = data.emboss.embossedText || {};
		data.emboss.embossedText.text = this.generateEmbossedText(line1, line2, side, orderID);
		data.emboss.embossedLogo = true;
		data.hpSpecific = data.hpSpecific || {};
		data.hpSpecific.advancedExportParams = data.hpSpecific.advancedExportParams || {};
		data.hpSpecific.advancedExportParams.plantarPatternEnabled = true;

		return data;
	}

	public static injectEmbossedTextAndFilenameToOrder(metadata: LeoMetadata | undefined, orderID: string, line1: string, line2: string) {
		if (!metadata) {
			return metadata;
		}
		metadata.left = LeroyUtils.injectEmbossedTextAndFilename(metadata?.left, line1, line2, 'L', orderID);
		metadata.right = LeroyUtils.injectEmbossedTextAndFilename(metadata?.right, line1, line2, 'R', orderID);
		return metadata;
	}

	public static saveFile(blob, filename) {
		if (window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(blob, filename);
		} else {
			const a = document.createElement('a');
			document.body.appendChild(a);
			const url = window.URL.createObjectURL(blob);
			a.href = url;
			a.download = filename;
			a.click();
			setTimeout(() => {
				window.URL.revokeObjectURL(url);
				document.body.removeChild(a);
			}, 100);
		}
	}
}
